import {useRemoteData} from '../../../common/utils/useRemoteData';
import {fetchAllBanners} from '../infrastructure/BannerFetcher';
import {useMemo} from 'react';
import {mapRemoteData} from '../../../common/domain/RemoteData.model';
import {isCatalog, isRegularBanner} from '../domain/Banner.model';

export const useBannersRemoteData = () => {
  const allBannersRemoteData =  useRemoteData({
    initialData: [],
    dataFetchingCallback: fetchAllBanners
  });

  const catalogsRemoteData = useMemo(() => {
    return mapRemoteData(allBannersRemoteData, (banners) => banners?.filter(isCatalog) ?? []);
  }, [allBannersRemoteData]);

  const bannersRemoteData = useMemo(() => {
    return mapRemoteData(allBannersRemoteData, (banners) => banners?.filter(isRegularBanner));
  }, [allBannersRemoteData]);

  return { catalogsRemoteData, bannersRemoteData };
}